<template>
  <v-container fluid class="pa-4 sdv2-container">

    <!-- ─── Loading overlay ─── -->
    <v-overlay v-model="overlay" color="white" opacity="1" persistent>
      <v-container style="text-align:center">
        <v-progress-circular :size="50" color="#234a98" indeterminate />
        <p class="pt-2" style="font-size:14px;color:#234a98">{{ $t('smartDispenser.loading') }}</p>
      </v-container>
    </v-overlay>

    <!-- ─── Sensor selection dialog ─── -->
    <v-dialog v-model="scelta" max-width="1200" width="95%" persistent>
      <v-card class="mb-4" flat>
        <v-card-title>{{ $t('smartDispenser.selectSensor') }}</v-card-title>
        <v-card-text>
          <v-layout class="mt-4" id="sdv2-dialog-selects">
            <v-flex class="px-2">
              <v-select v-model="client" :items="clients" :label="$t('manageSensors.client')" outlined :no-data-text="$t('common.noDataAvailable')" />
            </v-flex>
            <v-flex class="px-2">
              <v-select v-model="building" :items="buildings" :label="$t('manageSensors.building')" outlined :disabled="buildingActive" :no-data-text="$t('common.noDataAvailable')" />
            </v-flex>
            <v-flex class="px-2">
              <v-select v-model="floor" :items="floors" :label="$t('manageSensors.floor')" outlined :disabled="floorActive" :no-data-text="$t('common.noDataAvailable')" />
            </v-flex>
            <v-flex class="px-2">
              <v-select v-model="area" :items="areas" :label="$t('manageSensors.area')" outlined :disabled="areaActive" :no-data-text="$t('common.noDataAvailable')" />
            </v-flex>
            <v-flex class="px-2">
              <v-select v-model="sensorsValue" :items="sensor_items" :label="$t('manageSensors.sensor')" outlined :key="s" :disabled="sensorActive" :no-data-text="$t('common.noDataAvailable')" />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="#213A8F" @click="goBack">{{ $t('common.back').toUpperCase() }}</v-btn>
          <v-btn text color="#213A8F" :disabled="okActive" @click="LoadData()">{{ $t('common.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ─── Main content ─── -->
    <div v-show="!scelta && !overlay">

      <!-- FILTER BAR (stesso stile di SmartDispenser.vue) -->
      <v-card class="mb-4" width="100%" flat>
        <v-card-text>
          <v-layout class="mt-4" id="changeMyColor">
            <v-flex xs6 sm3 md3>
              <v-select class="v-select" v-model="client" :items="clients"
                :label="$t('manageSensors.client')" outlined
                :no-data-text="$t('common.noDataAvailable')" />
            </v-flex>
            <v-flex xs6 sm3 md3>
              <v-select class="ml-2" v-model="building" :items="buildings"
                :label="$t('manageSensors.building')" outlined :key="b"
                :no-data-text="$t('common.noDataAvailable')" />
            </v-flex>
            <v-flex xs6 sm3 md3>
              <v-select class="ml-2" v-model="floor" :items="floors"
                :label="$t('manageSensors.floor')" outlined :key="f"
                :disabled="floorActive" :no-data-text="$t('common.noDataAvailable')" />
            </v-flex>
            <v-flex xs6 sm3 md3>
              <v-select class="ml-2" v-model="area" :items="areas"
                :label="$t('manageSensors.area')" outlined
                :disabled="areaActive" :no-data-text="$t('common.noDataAvailable')" />
            </v-flex>
            <v-flex xs6 sm3 md3>
              <v-select class="ml-2" v-model="sensorsValue" :items="sensor_items"
                :label="$t('manageSensors.sensor')" outlined :key="s"
                :disabled="sensorActive" :no-data-text="$t('common.noDataAvailable')" />
            </v-flex>
            <v-flex xs6 sm3 md3 class="ml-2">
              <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field outlined v-model="date"
                    :label="$t('smartDispenser.selectDateRange')"
                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" />
                </template>
                <v-date-picker v-model="date" no-title scrollable locale="en" range
                  :max="maxDate" :min="minDate" @click="SetMinDate">
                  <v-spacer />
                  <v-btn text color="primary" @click="menu = false">{{ $t('common.cancel') }}</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date); GetDataByDate()">{{ $t('common.ok') }}</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <!-- QUICK FILTERS + INCLUDE WEEKENDS + PERIOD DISPLAY -->
      <v-card flat class="mb-4 sdv2-filter-bar" v-show="visualizza_dati">
        <v-card-text>
          <!-- Riga 1: label + bottoni filtri rapidi -->
          <v-row align="center" no-gutters>
            <v-col cols="auto" class="mr-2" style="white-space:nowrap">
              <h2 style="font-weight:bold">{{ $t('smartDispenser.quickFilters') }}</h2>
            </v-col>
            <v-col style="overflow-x:auto; white-space:nowrap; min-width:0">
              <v-btn text @click="ChangeDate('4h')" class="mt-4 mb-4 mr-0 ml-0">
                <h2 :style="'color:' + colore4h">| {{ $t('smartDispenser.hours') }} |</h2>
              </v-btn>
              <v-btn text @click="ChangeDate('1')" class="mt-4 mb-4 mr-0 ml-0">
                <h2 :style="'color:' + colore1d">| {{ $t('smartDispenser.day') }} |</h2>
              </v-btn>
              <v-btn text @click="ChangeDate('3')" class="mt-4 mb-4 mr-0 ml-0">
                <h2 :style="'color:' + colore3d">| {{ $t('smartDispenser.threeDays') }} |</h2>
              </v-btn>
              <v-btn text @click="ChangeDate('7')" class="mt-4 mb-4 mr-0 ml-0">
                <h2 :style="'color:' + colore1w">| {{ $t('smartDispenser.week') }} |</h2>
              </v-btn>
              <v-btn text @click="ChangeDate('14')" class="mt-4 mb-4 mr-0 ml-0">
                <h2 :style="'color:' + colore2w">| {{ $t('smartDispenser.twoWeeks') }} |</h2>
              </v-btn>
              <v-btn text @click="ChangeDate('30')" class="mt-4 mb-4 mr-0 ml-0">
                <h2 :style="'color:' + colore1m">| {{ $t('smartDispenser.lastMonth') }} |</h2>
              </v-btn>
            </v-col>
          </v-row>
          <!-- Riga 2: toggle "Includi weekend" + periodo selezionato, su riga dedicata -->
          <v-row align="center" no-gutters class="mt-1">
            <v-col cols="auto">
              <div v-if="formattedPeriod">
                <span class="caption" style="color:#8899BB">
                  {{ $t('smartDispenser.selectedPeriod') }}: {{ formattedPeriod }}
                </span>
              </div>
            </v-col>
            <v-spacer />
            <v-col cols="auto" class="d-flex align-center">
              <span class="mr-2" style="font-size:14px; color:#213A8F">{{ $t('smartDispenser.includeWeekends') }}</span>
              <v-switch v-model="includeWeekends" color="#213A8F" dense hide-details inset class="mt-0 pt-0" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- ── OVERVIEW CARD + CURRENT LEVEL CARD ── -->
      <v-row class="mb-4" v-show="visualizza_dati" align="stretch">

        <!-- Dispenser Overview -->
        <v-col cols="12" md="6" style="display:flex">
          <v-card outlined class="pa-4 sdv2-card" style="min-height:220px; width:100%">
            <div class="d-flex align-center mb-2">
              <span class="sdv2-overline mr-2">{{ $t('smartDispenser.dispenserOverview').toUpperCase() }}</span>
              <v-chip x-small :color="statusChipColor" :text-color="statusChipTextColor" class="sdv2-badge">
                <v-icon x-small left>{{ isOnline ? 'mdi-circle' : 'mdi-circle-outline' }}</v-icon>
                {{ isOnline ? $t('smartDispenser.online') : $t('smartDispenser.offline') }}
              </v-chip>
            </div>
            <div class="sdv2-sensor-name mb-1">{{ sensor_name }}</div>
            <div class="caption sdv2-muted mb-1" v-if="locationBreadcrumb">
              <v-icon x-small class="mr-1">mdi-map-marker-outline</v-icon>{{ locationBreadcrumb }}
            </div>
            <div class="caption sdv2-muted mb-3" v-if="dispenserTypeLabel">
              <v-icon x-small class="mr-1">mdi-package-variant-closed</v-icon>
              {{ $t('smartDispenser.dispenserType') }}: {{ dispenserTypeLabel }}
            </div>
            <v-row dense>
              <v-col cols="4">
                <v-card outlined class="sdv2-info-tile pa-3">
                  <div class="d-flex justify-space-between align-start">
                    <div class="caption sdv2-muted">{{ $t('smartDispenser.lastDataReceived') }}</div>
                    <v-icon small color="#213A8F">mdi-wifi</v-icon>
                  </div>
                  <div class="sdv2-info-value mt-2">{{ formattedLastDataReceived }}</div>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card outlined class="sdv2-info-tile pa-3">
                  <div class="d-flex justify-space-between align-start">
                    <div class="caption sdv2-muted">{{ $t('smartDispenser.lastRefill') }}</div>
                    <v-icon small color="#213A8F">mdi-calendar-clock</v-icon>
                  </div>
                  <div class="sdv2-info-value mt-2">{{ formattedLastRefill }}</div>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card outlined class="sdv2-info-tile pa-3">
                  <div class="d-flex justify-space-between align-start">
                    <div class="caption sdv2-muted">{{ $t('smartDispenser.refillThreshold') }}</div>
                    <v-icon small color="orange darken-1">mdi-bell-outline</v-icon>
                  </div>
                  <div class="sdv2-info-value mt-2">{{ alertThreshold ? alertThreshold + '%' : $t('smartDispenser.notAvailable') }}</div>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- Current Level -->
        <v-col cols="12" md="6" style="display:flex">
          <v-card outlined class="pa-4 sdv2-card" style="min-height:220px; width:100%; display:flex; flex-direction:column">
            <div class="d-flex justify-space-between align-center mb-2">
              <span class="sdv2-overline">{{ $t('smartDispenser.currentLevel').toUpperCase() }}</span>
              <div class="d-flex align-center" style="gap:6px">
                <v-chip x-small
                  :color="isAboveThreshold ? '#E8F5E9' : '#FFF3E0'"
                  :text-color="isAboveThreshold ? '#2E7D32' : '#E65100'"
                  class="sdv2-badge">
                  {{ isAboveThreshold ? $t('smartDispenser.aboveRefillThreshold') : $t('smartDispenser.belowRefillThreshold') }}
                </v-chip>
                <v-icon small color="#BFCCE4">mdi-wifi</v-icon>
              </div>
            </div>
            <div class="sdv2-level-pct mb-0">{{ currentLevelPct }}%</div>
            <div class="caption sdv2-muted mb-3" v-if="currentCapacityLabel">{{ currentCapacityLabel }}</div>

            <!-- Level bar + Legend pushed to bottom -->
            <div style="margin-top:auto">
              <!-- Level bar -->
              <div class="sdv2-bar-wrapper mb-2">
                <div class="sdv2-bar-threshold-label" :style="{left: clamp(alertThreshold, 5, 88) + '%'}">
                  {{ $t('smartDispenser.threshold') }} {{ alertThreshold }}%
                </div>
                <div class="sdv2-bar">
                  <div class="sdv2-bar-fill" :style="{width: currentLevelPct + '%'}">
                    <span v-if="currentLevelPct > 10" class="sdv2-bar-fill-label">{{ currentLevelPct }}%</span>
                  </div>
                  <div class="sdv2-bar-marker" :style="{left: alertThreshold + '%'}" />
                </div>
              </div>

              <!-- Legend -->
              <div class="d-flex align-center sdv2-legend">
                <span class="sdv2-legend-dot" style="background:#009CAB" />
                <span class="caption mr-3">{{ $t('smartDispenser.availableLevel') }}</span>
                <span class="sdv2-legend-line" />
                <span class="caption mr-3">{{ $t('smartDispenser.threshold') }}</span>
                <span class="sdv2-legend-dot" style="background:#BFCCE4" />
                <span class="caption">{{ $t('smartDispenser.remainingCapacity') }}</span>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- ── KPI CARDS ── -->
      <v-row dense class="mb-5" v-show="visualizza_dati">

        <!-- 1. Avg Daily Consumption -->
        <v-col cols="6" sm="4" md="2">
          <v-card flat class="sdv2-kpi-card pa-3">
            <div class="sdv2-kpi-icon"><v-icon color="#213A8F">mdi-chart-bar</v-icon></div>
            <div class="sdv2-kpi-label">{{ $t('smartDispenser.avgDailyConsumption') }}</div>
            <div class="sdv2-kpi-value">{{ avgDailyConsumptionValue }}</div>
            <div class="sdv2-kpi-sub">{{ consumptionUnitPerDay }}</div>
          </v-card>
        </v-col>

        <!-- 2. Avg Daily Fill Level -->
        <v-col cols="6" sm="4" md="2">
          <v-card flat class="sdv2-kpi-card pa-3">
            <div class="sdv2-kpi-icon"><v-icon color="#213A8F">mdi-gauge</v-icon></div>
            <div class="sdv2-kpi-label">{{ $t('smartDispenser.avgDailyFillLevel') }}</div>
            <div class="sdv2-kpi-value">{{ avgDailyFillLevel !== null ? avgDailyFillLevel + '%' : $t('smartDispenser.notAvailable') }}</div>
            <div class="sdv2-kpi-sub">{{ $t('smartDispenser.averageDispenserLevel') }}</div>
          </v-card>
        </v-col>

        <!-- 3. Avg Refill Interval -->
        <v-col cols="6" sm="4" md="2">
          <v-card flat class="sdv2-kpi-card pa-3">
            <div class="sdv2-kpi-icon"><v-icon color="#213A8F">mdi-clock-outline</v-icon></div>
            <div class="sdv2-kpi-label">{{ $t('smartDispenser.avgRefillInterval') }}</div>
            <div class="sdv2-kpi-value">{{ avgRefillInterval !== null ? avgRefillInterval + ' d' : $t('smartDispenser.notAvailable') }}</div>
            <div class="sdv2-kpi-sub">{{ $t('smartDispenser.daysBetweenRefills') }}</div>
          </v-card>
        </v-col>

        <!-- 4. Avg Daily Empty Hours -->
        <v-col cols="6" sm="4" md="2">
          <v-card flat class="sdv2-kpi-card pa-3">
            <div class="sdv2-kpi-icon"><v-icon color="orange darken-1">mdi-alert-circle-outline</v-icon></div>
            <div class="sdv2-kpi-label">{{ $t('smartDispenser.avgDailyEmptyHours') }}</div>
            <div class="sdv2-kpi-value">{{ avgDailyEmptyHours !== null ? avgDailyEmptyHours + ' h' : $t('smartDispenser.notAvailable') }}</div>
            <div class="sdv2-kpi-sub">{{ $t('smartDispenser.downtimePerDay') }}</div>
          </v-card>
        </v-col>

        <!-- 5. Avg Daily Availability -->
        <v-col cols="6" sm="4" md="2">
          <v-card flat class="sdv2-kpi-card pa-3">
            <div class="sdv2-kpi-icon"><v-icon color="green darken-1">mdi-check-circle-outline</v-icon></div>
            <div class="sdv2-kpi-label">{{ $t('smartDispenser.avgDailyAvailability') }}</div>
            <div class="sdv2-kpi-value">{{ avgDailyAvailability !== null ? avgDailyAvailability + '%' : $t('smartDispenser.notAvailable') }}</div>
            <div class="sdv2-kpi-sub">{{ $t('smartDispenser.timeAboveEmptyLevel') }}</div>
          </v-card>
        </v-col>

        <!-- 6. Avg Level at Refill -->
        <v-col cols="6" sm="4" md="2">
          <v-card flat class="sdv2-kpi-card pa-3">
            <div class="sdv2-kpi-icon"><v-icon color="#213A8F">mdi-package-variant-closed</v-icon></div>
            <div class="sdv2-kpi-label">{{ $t('smartDispenser.avgLevelAtRefill') }}</div>
            <div class="sdv2-kpi-value">{{ avgLevelAtRefill !== null ? avgLevelAtRefill + '%' : $t('smartDispenser.notAvailable') }}</div>
            <div class="sdv2-kpi-sub">{{ $t('smartDispenser.levelWhenRefillHappens') }}</div>
          </v-card>
        </v-col>
      </v-row>

      <!-- ── CHARTS ── -->
      <hr style="border-top:1px solid #BFCCE4" class="mb-4" v-show="visualizza_dati" />

      <!-- Dispenser Level Line Chart -->
      <v-row class="mb-4" v-show="visualizza_dati">
        <v-col cols="12">
          <v-card flat outlined class="pa-4 sdv2-card">
            <h3 style="color:#213A8F" class="mb-3">{{ $t('smartDispenser.dispenserLevel') }}</h3>
            <div :key="'wrapper-' + keyBin">
              <apexchartComponent
                v-if="!isLoadingChart && series_dispenser && series_dispenser.length > 0"
                type="line" height="300"
                :options="chartOptions_bin"
                :series="series_dispenser" />
              <div v-else style="padding:40px;text-align:center;color:#999">
                <v-progress-circular indeterminate color="#213A8F" />
              </div>
            </div>
            <div class="mt-2" v-if="$store.state.company == '1'">
              <v-btn text color="#213A8F" @click="DownloadCsv()"><v-icon>mdi-download</v-icon>{{ $t('smartDispenser.downloadChartData') }}</v-btn>
              <v-btn text color="#213A8F" @click="DownloadCompleteCsv()"><v-icon>mdi-download</v-icon>{{ $t('smartDispenser.downloadAllData') }}</v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Dispenser Availability Stacked Chart -->
      <v-row class="mb-4" v-show="visualizza_dati && series_stacked && series_stacked.length > 0">
        <v-col cols="12">
          <v-card flat outlined class="pa-4 sdv2-card">
            <h3 style="color:#213A8F" class="mb-3">{{ $t('smartDispenser.dispenserAvailability') }}</h3>
            <apexchartComponent
              type="bar" height="300"
              :options="chartOptions_stacked"
              :series="series_stacked"
              :key="'chart-stacked-' + keyStacked"
              @mousedown.prevent @touchstart.prevent />
          </v-card>
        </v-col>
      </v-row>

      <!-- Dispenser Downtime Bar Chart -->
      <v-row class="mb-4" v-show="visualizza_dati && series_bar && series_bar.length > 0">
        <v-col cols="12">
          <v-card flat outlined class="pa-4 sdv2-card">
            <h3 style="color:#213A8F" class="mb-3">{{ $t('smartDispenser.dispenserDowntime') }}</h3>
            <apexchartComponent
              type="bar" height="300"
              :options="chartOptions_bar"
              :series="series_bar"
              :key="'chart-bar-' + keyBar"
              @mousedown.prevent @touchstart.prevent />
          </v-card>
        </v-col>
      </v-row>

      <!-- Consumptions Chart -->
      <v-row class="mb-4" v-show="visualizza_dati && okconsumption && series_consumptions && series_consumptions.length > 0">
        <v-col cols="12">
          <v-card flat outlined class="pa-4 sdv2-card">
            <h3 style="color:#213A8F" class="mb-3">{{ $t('smartDispenser.consumptions') }}</h3>
            <apexchartComponent
              type="bar" height="300"
              :options="chartOptions_cons"
              :series="series_consumptions"
              :key="'chart-cons-' + keyCons"
              @mousedown.prevent @touchstart.prevent />
          </v-card>
        </v-col>
      </v-row>

    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import { addPeriodSubtitleToChartOptions } from '@/utils/chartPeriodFormatter';
import { applyTimezoneToApexCharts } from '@/utils/chartDateFormatter';
import { parseDateAsCET, normalizeTimezone } from '@/utils/dateTimezone';

export default {
  name: 'SmartDispenserV2',
  data() {
    return {
      // ─── UI state ───
      overlay: true,
      scelta: true,
      isLoadingChart: false,
      visualizza_dati: false,
      menu: false,
      isLoadingFromRoute: false,

      // ─── Filters ───
      client: '',
      building: '',
      floor: '',
      area: '',
      sensorsValue: '',
      date: [],
      maxDate: '',
      minDate: '',
      includeWeekends: true,

      // ─── Dropdowns ───
      clients: [],
      buildings: [],
      floors: [],
      areas: [],
      sensor_items: [],
      buildingActive: true,
      floorActive: true,
      areaActive: true,
      sensorActive: true,
      okActive: true,
      i: 0, b: 0, f: 0, s: 0,

      // ─── Refill stats from DB ───
      // lastRefillFromDb: ultimo refill assoluto (senza filtro periodo) → tile overview
      lastRefillFromDb: null,
      // refillStatsFromDb: statistiche filtrate per periodo → KPI cards
      refillStatsFromDb: {
        lastRefill: null,
        avgRefillIntervalDays: null,
        refillCount: 0,
      },

      // ─── Sensor info ───
      sensor_name: '',
      sensor_img: '',
      sensor_unique: '',
      sensor_id: '',
      sensor_id_numeric: null, // ID numerico per le API (es. alert management)
      dispenserSubtype: '',
      minValue: 0,
      maxValue: 0,
      alertThreshold: 0,
      numeroFoglietti: 0,
      building_name: '',
      floor_name: '',
      last_refill: '',
      lastDataReceivedTimestamp: '',

      // ─── Period ───
      currentStartDate: null,
      currentEndDate: null,

      // ─── Quick filter colors ───
      colore4h: '#DAE0EC',
      colore1d: '#213A8F',
      colore3d: '#DAE0EC',
      colore1w: '#DAE0EC',
      colore2w: '#DAE0EC',
      colore1m: '#DAE0EC',

      // ─── Status ───
      colore_stato: 'gray',
      GiornoSettimana: '',
      OraSensore: '',
      DataSensore: '',

      // ─── Raw data for KPIs ───
      rawDispenserData: [],   // [{value: %, received_at: string}]
      stackedDailyData: [],   // [{Vuoto, Pieno, OreVuoto, DataRegistrazione}]

      // ─── Chart series ───
      series_dispenser: [],
      series_stacked: [],
      series_bar: [],
      series_consumptions: [],
      series_punctual: [],
      datiPerCsv: [],
      start_complete: '',
      nextDay_complete: '',
      weeklyCons: 0,
      okconsumption: false,

      // ─── Chart keys ───
      keyBin: 0,
      keyStacked: 0,
      keyBar: 0,
      keyCons: 0,
      radialKey: 0,

      // ─── Chart options ───
      chartOptions_bin: {
        colors: ['#BFCCE4'],
        chart: { toolbar: { show: false }, type: 'line', height: 300 },
        yaxis: {
          min: 0, max: 100,
          labels: {
            style: { colors: '#BFCCE4' },
            formatter: v => Number(v).toFixed(0) + '%'
          }
        },
        xaxis: {
          colors: '#213A8F', categories: [],
          labels: { style: { colors: '#213A8F', fontSize: '8px' } }
        },
        fill: { opacity: 1 },
        legend: { show: false }
      },
      chartOptions_stacked: {
        states: { hover: { filter: { type: 'none' } } },
        plotOptions: { bar: { columnWidth: '20%' } },
        chart: { toolbar: { show: false }, type: 'bar', height: 300, stacked: true, stackType: '100%' },
        yaxis: {
          labels: {
            style: { colors: '#BFCCE4' },
            formatter: v => Number(v).toFixed(0) + '%'
          }
        },
        xaxis: {
          categories: [],
          labels: { style: { colors: '#213A8F', fontSize: '8px' } }
        },
        fill: { colors: ['#BFCCE4', '#213A8F'] },
        legend: {
          show: true, position: 'top',
          labels: { colors: '#213A8F' }
        }
      },
      chartOptions_bar: {
        states: { hover: { filter: { type: 'none' } } },
        plotOptions: { bar: { columnWidth: '20%' } },
        chart: { toolbar: { show: false }, type: 'bar', height: 300 },
        dataLabels: { enabled: false },
        fill: { colors: ['#BFCCE4'] },
        xaxis: {
          categories: [],
          labels: { style: { colors: '#213A8F', fontSize: '8px' } }
        },
        yaxis: {
          labels: {
            style: { colors: '#BFCCE4' },
            formatter: val => Math.round(val) + ' h'
          }
        },
        colors: '#BFCCE4'
      },
      chartOptions_cons: {
        states: { hover: { filter: { type: 'none' } } },
        chart: { toolbar: { show: false }, type: 'bar', height: 300 },
        dataLabels: {
          enabled: true,
          formatter: (val) => val != null ? val.toFixed(0) : '',
          style: { colors: ['#ffffff'], fontWeight: 'bold', fontSize: '12px' }
        },
        plotOptions: { bar: { columnWidth: '20%', borderRadius: 4, dataLabels: { position: 'center' } } },
        xaxis: {
          categories: [],
          labels: { style: { colors: '#213A8F', fontSize: '8px' } }
        },
        yaxis: {
          labels: {
            style: { colors: '#BFCCE4' },
            formatter: val => val != null ? val.toFixed(0) : ''
          }
        },
        tooltip: {
          y: { formatter: val => val != null ? val.toFixed(0) : '' }
        },
        colors: ['#BFCCE4']
      }
    };
  },

  computed: {
    // ─── Quick filter buttons ───
    quickFilters() {
      return [
        { period: '4h', label: this.$t('smartDispenser.hours'), color: this.colore4h },
        { period: '1',  label: this.$t('smartDispenser.day'),   color: this.colore1d },
        { period: '3',  label: this.$t('smartDispenser.threeDays'), color: this.colore3d },
        { period: '7',  label: this.$t('smartDispenser.week'),  color: this.colore1w },
        { period: '14', label: this.$t('smartDispenser.twoWeeks'), color: this.colore2w },
        { period: '30', label: this.$t('smartDispenser.lastMonth'), color: this.colore1m }
      ];
    },

    // ─── Location ───
    clientName() {
      const f = this.clients.find(c => c.value === this.client);
      return f ? f.text : '';
    },
    areaName() {
      const f = this.areas.find(a => a.value === this.area);
      return f ? f.text : '';
    },
    locationBreadcrumb() {
      return [this.clientName, this.building_name, this.floor_name, this.areaName]
        .filter(Boolean).join(' · ');
    },

    // ─── Dispenser type label (localized) ───
    dispenserTypeLabel() {
      const sub = (this.dispenserSubtype || '').toLowerCase().trim();
      if (!sub) return '';
      if (sub.includes('folded') && (sub.includes('towel') || sub.includes('hand')))
        return this.$t('manageSensors.dispenserSubtypes.foldedHandTowels');
      if ((sub.includes('roll') || sub.includes('roul')) && sub.includes('towel'))
        return this.$t('manageSensors.dispenserSubtypes.handTowelRolls');
      if (sub.includes('folded') && sub.includes('toilet'))
        return this.$t('manageSensors.dispenserSubtypes.foldedToiletPaper');
      if (sub.includes('roll') && sub.includes('toilet'))
        return this.$t('manageSensors.dispenserSubtypes.toiletPaperRolls');
      if (sub.includes('soap')) return this.$t('manageSensors.dispenserSubtypes.soap');
      return this.dispenserSubtype;
    },

    // ─── Consumption unit ───
    consumptionUnit() {
      const sub = (this.dispenserSubtype || '').toLowerCase().trim();
      if (!sub) return '';
      if (sub.includes('soap')) return this.$t('smartDispenser.units.milliliters');
      if (sub.includes('roll')) return this.$t('smartDispenser.units.rolls');
      return this.$t('smartDispenser.units.sheets');
    },
    consumptionUnitPerDay() {
      const sub = (this.dispenserSubtype || '').toLowerCase().trim();
      if (sub.includes('soap')) return this.$t('smartDispenser.mlUsedPerDay');
      if (sub.includes('roll')) return this.$t('smartDispenser.rollsUsedPerDay');
      return this.$t('smartDispenser.sheetsUsedPerDay');
    },

    // ─── Status ───
    // Online se GetTodayStatus ha trovato dati oggi (colore != gray)
    isOnline() {
      return this.colore_stato !== 'gray';
    },

    // Il badge Online/Offline mostra solo verde (online) o grigio (offline),
    // slegato dal livello del dispenser (green/orange/red)
    statusChipColor() {
      return this.isOnline ? '#E8F5E9' : '#EEEEEE';
    },
    statusChipTextColor() {
      return this.isOnline ? '#2E7D32' : '#757575';
    },

    // ─── Current level ───
    currentLevelPct() {
      if (!this.series_punctual || !this.series_punctual[0]) return 0;
      return this.series_punctual[0].data[0] || 0;
    },
    isAboveThreshold() {
      return this.currentLevelPct > this.alertThreshold;
    },
    currentCapacityLabel() {
      if (!this.numeroFoglietti || this.numeroFoglietti <= 0) return '';
      const count = Math.round(this.currentLevelPct * this.numeroFoglietti / 100);
      const sub = (this.dispenserSubtype || '').toLowerCase();
      let unit = sub.includes('soap') ? 'ml' : sub.includes('roll') ? this.$t('smartDispenser.units.rolls') : this.$t('smartDispenser.units.sheets');
      return `${this.$t('smartDispenser.currentCapacity')}: ${count} ${unit}`;
    },

    // ─── Formatted timestamps ───
    formattedLastDataReceived() {
      if (!this.lastDataReceivedTimestamp) return '–';
      return this.formatTimestamp(this.lastDataReceivedTimestamp);
    },
    formattedLastRefill() {
      // Sorgente unica: tabella DispenserRefillEvents (ultimo refill assoluto)
      if (this.lastRefillFromDb?.timestamp) {
        return this.formatTimestamp(this.lastRefillFromDb.timestamp);
      }
      return this.$t('sensor.notManagedYet');
    },

    // ─── Period ───
    formattedPeriod() {
      if (!this.currentStartDate || !this.currentEndDate) return '';
      const start = this.currentStartDate.substr(0, 10);
      const end = this.currentEndDate.substr(0, 10);
      return this.formatDate(start) + ' – ' + this.formatDate(end);
    },
    currentPeriodDays() {
      if (!this.currentStartDate || !this.currentEndDate) return 1;
      const s = new Date(this.currentStartDate.substr(0, 10));
      const e = new Date(this.currentEndDate.substr(0, 10));
      return Math.max(1, Math.round((e - s) / 86400000) + 1);
    },

    // ─── Weekend-filtered data ───
    filteredStackedData() {
      if (this.includeWeekends) return this.stackedDailyData;
      return this.stackedDailyData.filter(d => {
        const day = new Date(d.DataRegistrazione).getDay();
        return day !== 0 && day !== 6;
      });
    },
    filteredDispenserData() {
      if (this.includeWeekends) return this.rawDispenserData;
      return this.rawDispenserData.filter(d => {
        const day = new Date(d.received_at).getDay();
        return day !== 0 && day !== 6;
      });
    },

    // ─── KPI: Avg Daily Consumption ───
    avgDailyConsumptionValue() {
      if (!this.weeklyCons) return this.$t('smartDispenser.notAvailable');
      const perDay = this.weeklyCons / this.currentPeriodDays;
      return perDay >= 10 ? Math.round(perDay) : perDay.toFixed(1);
    },

    // ─── KPI: Avg Daily Fill Level ───
    avgDailyFillLevel() {
      const data = this.filteredDispenserData;
      if (data.length === 0) return null;
      const sum = data.reduce((acc, d) => acc + d.value, 0);
      return Math.round(sum / data.length);
    },

    // ─── Refill events (≥30% upward variation) ───
    refillEvents() {
      const data = this.filteredDispenserData;
      if (data.length < 2) return [];
      const events = [];
      for (let i = 1; i < data.length; i++) {
        const delta = data[i].value - data[i - 1].value;
        if (delta >= 30) {
          events.push({
            date: new Date(data[i].received_at),
            receivedAt: data[i].received_at,
            levelBefore: data[i - 1].value,
            levelAfter: data[i].value
          });
        }
      }
      return events;
    },

    // ─── KPI: Avg Refill Interval ───
    // Sorgente primaria: media degli intervalli consecutivi tra refill reali (dal DB).
    // Fallback: media dei delta temporali tra eventi di ricarica consecutivi rilevati dal grafico.
    avgRefillInterval() {
      if (this.refillStatsFromDb.avgRefillIntervalDays !== null) {
        const v = this.refillStatsFromDb.avgRefillIntervalDays;
        return v >= 10 ? Math.round(v) : Number(v.toFixed(1));
      }
      // Fallback: servono almeno 2 eventi per calcolare un intervallo
      const events = this.refillEvents;
      if (events.length < 2) return null;
      let totalMs = 0;
      for (let i = 1; i < events.length; i++) {
        totalMs += events[i].date - events[i - 1].date;
      }
      const avgDays = totalMs / (events.length - 1) / 86400000;
      return avgDays >= 10 ? Math.round(avgDays) : Number(avgDays.toFixed(1));
    },

    // ─── KPI: Avg Daily Empty Hours ───
    avgDailyEmptyHours() {
      const data = this.filteredStackedData;
      if (data.length === 0) return null;
      const sum = data.reduce((acc, d) => acc + (Number(d.OreVuoto) || 0), 0);
      const avg = sum / data.length;
      return avg >= 10 ? Math.round(avg) : avg.toFixed(1);
    },

    // ─── KPI: Avg Daily Availability ───
    avgDailyAvailability() {
      const data = this.filteredStackedData;
      if (data.length === 0) return null;
      const sum = data.reduce((acc, d) => acc + (Number(d.Pieno) || 0), 0);
      return Math.round(sum / data.length);
    },

    // ─── KPI: Avg Level at Refill ───
    avgLevelAtRefill() {
      const events = this.refillEvents;
      if (events.length === 0) return null;
      const sum = events.reduce((acc, e) => acc + e.levelBefore, 0);
      return Math.round(sum / events.length);
    }
  },

  watch: {
    '$store.state.timezone'() { this.applyChartsTimezone(); },
    consumptionUnit(unit) {
      if (this.chartOptions_cons) {
        this.$set(this.chartOptions_cons, 'yaxis', {
          labels: {
            style: { colors: '#BFCCE4' },
            formatter: val => val != null ? `${val.toFixed(0)}${unit ? ' ' + unit : ''}` : ''
          }
        });
        this.$set(this.chartOptions_cons, 'tooltip', {
          y: { formatter: val => val != null ? `${val.toFixed(0)}${unit ? ' ' + unit : ''}` : '' }
        });
      }
      this.keyCons++;
    },
    client(value) {
      if (this.isLoadingFromRoute) return;
      this.resetCascadeFrom('client');
      if (value) {
        this.buildingActive = false;
        axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, { companyId: value })
          .then(res => res.data.forEach(el => this.buildings.push({ text: el.BuildingName, value: el.id })));
      }
    },
    building(value) {
      if (this.isLoadingFromRoute) return;
      this.resetCascadeFrom('building');
      if (value) {
        const sel = this.buildings.find(o => o.value === value);
        if (sel) this.building_name = sel.text;
        this.floorActive = false;
        axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, { buildingId: value })
          .then(res => res.data.forEach(el => this.floors.push({ text: el.FloorName, value: el.id })));
      }
    },
    floor(value) {
      if (this.isLoadingFromRoute) return;
      this.resetCascadeFrom('floor');
      if (value) {
        const sel = this.floors.find(o => o.value === value);
        if (sel) this.floor_name = sel.text;
        this.areaActive = false;
        axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, { floorId: value })
          .then(res => res.data.forEach(el => this.areas.push({ text: el.AreaName, value: el.id })));
      }
    },
    area(value) {
      if (this.isLoadingFromRoute) return;
      this.resetCascadeFrom('area');
      if (value) {
        this.sensorActive = false;
        axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
          companyId: this.client, buildingId: this.building,
          floorId: this.floor, areaId: value, type: 'Dispenser'
        }).then(res => res.data.forEach(el => this.sensor_items.push({ text: el.DisplayName, value: el })));
      }
    },
    sensorsValue(value) {
      if (!value || this.isLoadingFromRoute) return;
      this.ResetCharts();
      this.visualizza_dati = true;
      this.sensor_name = value.DisplayName;
      this.sensor_img = value.DispenserImage;
      this.dispenserSubtype = value.DispenserSubtype || value.dispenserSubtype || '';
      this.sensor_unique = value.DispenserUnique;
      this.sensor_id = value.DispenserId || value.DispenserUnique || value.id;
      this.sensor_id_numeric = value.id || value.DispenserId; // ID numerico per alert management
      this.minValue = value.Min_Value;
      this.maxValue = value.Max_Value;
      this.alertThreshold = Number(value.AlertValue) || 0;
      this.numeroFoglietti = Number(value.NumeroFoglietti) || 0;
      this.okActive = false;
      this.resetQuickFilterColors();
      this.colore1d = '#213A8F';
      this.date = [];
      this.fetchAlertThreshold(this.sensor_unique);
      this.fetchLastRefill(this.sensor_unique);
      this.LoadData();
    }
  },

  created() {
    this.overlay = true;
    this.initializeComponent();
  },

  mounted() {
    this.applyChartsTimezone();
  },

  methods: {
    // ─── Helpers ───
    clamp(val, min, max) { return Math.min(Math.max(val, min), max); },

    formatTimestamp(ts) {
      if (!ts) return '–';
      // Normalizza formati con punti: "2026.03.26T18:32:39" → "2026-03-26T18:32:39"
      const normalized = ts.replace(/^(\d{4})\.(\d{2})\.(\d{2})/, '$1-$2-$3');
      // parseDateAsCET interpreta i timestamp del backend (sempre in CET) come UTC corretto
      const d = parseDateAsCET(normalized);
      if (!d || isNaN(d.getTime())) return ts;
      const tz = normalizeTimezone(this.$store.state.timezone || 'Europe/Rome');
      try {
        const parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: tz,
          day: 'numeric', month: 'short', year: 'numeric',
          hour: '2-digit', minute: '2-digit', hour12: false
        }).formatToParts(d);
        const get = type => (parts.find(p => p.type === type) || {}).value || '';
        return `${get('day')} ${get('month')} ${get('year')} · ${get('hour')}:${get('minute')}`;
      } catch (e) {
        return ts;
      }
    },

    formatDate(dateStr) {
      const d = new Date(dateStr);
      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    },

    resetQuickFilterColors() {
      this.colore4h = '#DAE0EC';
      this.colore1d = '#DAE0EC';
      this.colore3d = '#DAE0EC';
      this.colore1w = '#DAE0EC';
      this.colore2w = '#DAE0EC';
      this.colore1m = '#DAE0EC';
    },

    resetCascadeFrom(level) {
      if (['client','building','floor','area'].indexOf(level) <= 0) {
        this.buildings = []; this.building = ''; this.building_name = '';
        this.buildingActive = level === 'client';
      }
      if (['building','floor','area'].indexOf(level) <= 0 || level === 'client') {
        this.floors = []; this.floor = ''; this.floor_name = ''; this.floorActive = true;
      }
      if (level !== 'area') {
        this.areas = []; this.area = ''; this.areaActive = true;
      }
      this.sensor_items = []; this.sensorsValue = ''; this.sensorActive = true;
    },

    clearFilter() {
      this.scelta = true;
      this.visualizza_dati = false;
    },

    goBack() {
      if (window.history.length > 1) this.$router.go(-1);
      else this.$router.push('/welcome');
    },

    // ─── Chart timezone ───
    applyChartsTimezone() {
      // chartOptions_bin usa categorie pre-formattate ("DD/MM HH:MM") che non necessitano conversione timezone
      applyTimezoneToApexCharts(
        { chartOptions_stacked: this.chartOptions_stacked,
          chartOptions_bar: this.chartOptions_bar, chartOptions_cons: this.chartOptions_cons },
        this.$store.state.timezone || 'Europe/Rome'
      );
    },

    // ─── Status ───
    calculateDispenserStatus(pct, threshold) {
      if (pct === -1 || pct == null) return 'gray';
      if (!threshold) {
        if (pct < 15) return 'red';
        if (pct < 40) return 'orange';
        return 'green';
      }
      if (pct <= threshold) return 'red';
      if (pct <= threshold + 30) return 'orange';
      return 'green';
    },

    // ─── Alert threshold from AlertManagement table ───
    async fetchAlertThreshold(devEui) {
      if (!devEui) return;
      try {
        const token = localStorage.getItem('token');
        const url = this.$store.state.BASE_URL + this.$store.state.URL_GET_ALERT_THRESHOLD + encodeURIComponent(devEui);
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data && res.data.alertValue != null) {
          this.alertThreshold = res.data.alertValue;
        }
      } catch (e) {
        // Mantiene il valore di fallback già impostato da AlertValue del sensore
      }
    },

    // ─── Ultimo refill assoluto dalla nuova tabella (senza filtro periodo) ───
    async fetchLastRefill(devEui) {
      if (!devEui) return;
      try {
        const token = localStorage.getItem('token');
        const url = `${this.$store.state.BASE_URL}${this.$store.state.URL_GET_REFILL_STATS}${encodeURIComponent(devEui)}`;
        const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
        this.lastRefillFromDb = res.data?.lastRefill ?? null;
      } catch (e) {
        this.lastRefillFromDb = null;
      }
    },

    // ─── Refill stats dal periodo selezionato (per KPI cards) ───
    async fetchRefillStats(devEui, from, to) {
      if (!devEui) return;
      try {
        const token = localStorage.getItem('token');
        const params = new URLSearchParams();
        if (from) params.append('from', from);
        if (to)   params.append('to',   to);
        const base = this.$store.state.BASE_URL + this.$store.state.URL_GET_REFILL_STATS;
        const url  = `${base}${encodeURIComponent(devEui)}?${params.toString()}`;
        const res  = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
        if (res.data) {
          this.refillStatsFromDb = {
            lastRefill:            res.data.lastRefill           ?? null,
            avgRefillIntervalDays: res.data.avgRefillIntervalDays ?? null,
            refillCount:           res.data.refillCount           ?? 0,
          };
        }
      } catch (e) {
        // Lascia i valori di fallback calcolati dal grafico
      }
    },

    // ─── Load & Reset ───
    LoadData() {
      this.scelta = false;
      this.ChangeDate('1');
      this.GetConsumptionData();
      this.GetTodayStatus().then(() => { this.overlay = false; }).catch(() => { this.overlay = false; });
    },

    ResetCharts() {
      this.$set(this, 'series_dispenser', []);
      this.$set(this, 'series_stacked', []);
      this.$set(this, 'series_bar', []);
      this.$set(this, 'series_consumptions', []);
      this.$set(this, 'series_punctual', []);
      this.rawDispenserData = [];
      this.stackedDailyData = [];
      this.last_refill = '';
      this.lastDataReceivedTimestamp = '';
      this.weeklyCons = 0;
      this.okconsumption = false;
      this.lastRefillFromDb = null;
      this.refillStatsFromDb = { lastRefill: null, avgRefillIntervalDays: null, refillCount: 0 };
      this.keyBin++; this.keyStacked++; this.keyBar++; this.keyCons++; this.radialKey++;
    },

    GetTodayStatus() {
      const today = new Date().toISOString().substr(0, 10);
      return axios.post(this.$store.state.URL_GET_DATA_FROM_DYNAMO, {
        sensor_id: this.sensor_unique,
        from: today + ' 00:00:00',
        to:   today + ' 23:59:59'
      }).then(res => {
        let dati = [];
        const arr = Array.isArray(res.data) ? res.data : (res.data.Items || []);
        for (let i = arr.length - 1; i >= 0; i--)
          if (arr[i].device_data && arr[i].device_data.received_at != null)
            dati.push(arr[i].device_data);
        if (dati.length === 0) {
          this.colore_stato = 'gray';
          this.lastDataReceivedTimestamp = '';
          return;
        }
        dati.sort((a, b) => a.received_at > b.received_at ? 1 : -1);
        const last = dati[dati.length - 1];
        let v = Math.trunc(100 - ((Number(last.tof_distance) - this.minValue) * 100) / (this.maxValue - this.minValue));
        v = Math.min(100, Math.max(0, v));
        this.colore_stato = this.calculateDispenserStatus(v, this.alertThreshold);
        // Imposta sempre il timestamp dall'ultima lettura di OGGI
        // (indipendente dal periodo selezionato nei grafici)
        this.lastDataReceivedTimestamp = last.received_at;
        const d = new Date(last.received_at.replace(' ', 'T'));
        const wd = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
        this.GiornoSettimana = wd[d.getDay()];
        this.OraSensore = last.received_at.substr(11, 5);
        this.DataSensore = last.received_at.substr(0, 10);
        this.radialKey++;
      }).catch(() => { this.colore_stato = 'gray'; throw new Error('GetTodayStatus failed'); });
    },

    // ─── Sensor data (line chart + raw data for KPIs) ───
    GetSensorData(start, nextDay, time = 0) {
      this.isLoadingChart = true;
      start   = start.length === 10   ? start   + ' 00:00:00' : start.replace('T', ' ');
      nextDay = nextDay.length === 10  ? nextDay + ' 23:59:59' : nextDay.replace('T', ' ');
      this.start_complete  = start;
      this.nextDay_complete = nextDay;

      axios.post(this.$store.state.URL_GET_DATA_FROM_DYNAMO, {
        sensor_id: this.sensor_unique, from: start, to: nextDay
      }).then(res => {
        const dataArray = Array.isArray(res.data) ? res.data : (res.data.Items || []);
        let dati = [];
        for (let i = dataArray.length - 1; i >= 0; i--)
          if (dataArray[i].device_data?.received_at != null && dataArray[i].device_data.tof_distance != null)
            dati.push(dataArray[i].device_data);

        if (dati.length === 0) {
          this.series_dispenser = [];
          this.series_punctual = [];
          this.rawDispenserData = [];
          this.isLoadingChart = false;
          this.overlay = false;
          this.visualizza_dati = true;
          return;
        }

        dati.sort((a, b) => a.received_at > b.received_at ? 1 : -1);
        this.lastDataReceivedTimestamp = dati[dati.length - 1].received_at;

        const data_ = [], categories = [];
        this.datiPerCsv = [];
        let precedente = 0, i2 = 0, val_ok = false;

        dati.forEach((el, index) => {
          let valore = Math.trunc(100 - ((Number(el.tof_distance) - this.minValue) * 100) / (this.maxValue - this.minValue));
          valore = Math.min(100, Math.max(0, valore));
          if (index === dati.length - 1) val_ok = true;
          else if (i2 !== 0 && Math.abs(precedente - valore) < 5) val_ok = false;
          else { val_ok = true; precedente = valore; }
          const push = val_ok ? valore : precedente;
          data_.push(push);
          this.datiPerCsv.push({ tof_distance: push, received_at: el.received_at });
          const day = el.received_at.substr(8, 2), mon = el.received_at.substr(5, 2);
          const timeStr = el.received_at.substr(11, 5);
          categories.push(time === 1 ? timeStr : `${day}/${mon} ${timeStr}`);
          i2++;
        });

        // Save raw data for KPI computation
        this.rawDispenserData = this.datiPerCsv.map(d => ({ value: d.tof_distance, received_at: d.received_at }));

        const ultimoValore = data_[data_.length - 1];
        let newChartOptions = { ...this.chartOptions_bin, xaxis: { ...this.chartOptions_bin.xaxis, categories: [...categories] } };
        if (this.currentStartDate && this.currentEndDate)
          newChartOptions = addPeriodSubtitleToChartOptions(newChartOptions, this.currentStartDate, this.currentEndDate, this.$i18n.locale || 'en');
        this.$set(this, 'chartOptions_bin', newChartOptions);
        this.applyChartsTimezone();
        this.$set(this, 'series_dispenser', [{ data: [...data_], name: this.sensor_name }]);
        this.$set(this, 'series_punctual', [
          { name: this.sensor_name, data: [ultimoValore] },
          { name: 'Full', data: [100 - ultimoValore] }
        ]);
        this.keyBin++;
        this.$nextTick(() => { this.isLoadingChart = false; });
        this.overlay = false;
      }).catch(() => { this.isLoadingChart = false; this.overlay = false; });

      this.visualizza_dati = true;
    },

    // ─── Stacked + bar data ───
    GetDataStacked(days) {
      axios.post(this.$store.state.URL_STACKED, { sensor: this.sensor_id, ndays: days })
        .then(res => {
          if (!res.data || res.data.length === 0) {
            this.series_stacked = []; this.series_bar = [];
            this.stackedDailyData = [];
            this.keyStacked++; this.keyBar++;
            return;
          }

          this.stackedDailyData = res.data;

          const categories = [], ore_vuoto = [], pieno = [], vuoto = [];
          res.data.forEach(el => {
            categories.push(el.DataRegistrazione);
            ore_vuoto.push(el.OreVuoto);
            pieno.push(el.Pieno);
            vuoto.push(el.Vuoto);
          });

          const dataCount = categories.length;
          const colW = dataCount <= 1 ? '8%' : dataCount <= 3 ? '20%' : dataCount <= 7 ? '40%' : dataCount <= 14 ? '60%' : '70%';

          this.$set(this, 'series_bar', [{ name: 'Empty hours', data: [...ore_vuoto] }]);
          this.$set(this, 'series_stacked', [{ name: 'Full', data: [...pieno] }, { name: 'Empty', data: [...vuoto] }]);

          let newOptStacked = { ...this.chartOptions_stacked, plotOptions: { ...this.chartOptions_stacked.plotOptions, bar: { ...this.chartOptions_stacked.plotOptions.bar, columnWidth: colW } }, xaxis: { ...this.chartOptions_stacked.xaxis, categories: [...categories] } };
          let newOptBar    = { ...this.chartOptions_bar,    plotOptions: { ...this.chartOptions_bar.plotOptions,    bar: { ...(this.chartOptions_bar.plotOptions?.bar || {}), columnWidth: colW } }, xaxis: { ...this.chartOptions_bar.xaxis,    categories: [...categories] } };

          if (this.currentStartDate && this.currentEndDate) {
            const locale = this.$i18n.locale || 'en';
            newOptStacked = addPeriodSubtitleToChartOptions(newOptStacked, this.currentStartDate, this.currentEndDate, locale);
            newOptBar     = addPeriodSubtitleToChartOptions(newOptBar,     this.currentStartDate, this.currentEndDate, locale);
          }
          this.$set(this, 'chartOptions_stacked', newOptStacked);
          this.$set(this, 'chartOptions_bar', newOptBar);
          this.applyChartsTimezone();
          this.keyStacked++; this.keyBar++;
        }).catch(() => {
          this.series_stacked = []; this.series_bar = [];
          this.stackedDailyData = [];
          this.keyStacked++; this.keyBar++;
        });
    },

    // ─── Consumption data ───
    GetConsumptionData(start, end) {
      const fmt = ds => { const d = new Date(ds); return `${d.getFullYear()}${String(d.getMonth()+1).padStart(2,'0')}${String(d.getDate()).padStart(2,'0')}`; };
      const s = start || this.subtractDays(-1, new Date()).toISOString().substr(0, 10);
      const e = end   || new Date().toISOString().substr(0, 10);
      axios.post(this.$store.state.URL_GET_WEEKLY_CONSUMPTION, { sensore: this.sensor_unique, data_inizio: fmt(s), data_fine: fmt(e) })
        .then(res => {
          if (res.data == null) { this.okconsumption = false; this.weeklyCons = 0; this.keyCons++; return; }
          this.weeklyCons = res.data;
          this.okconsumption = true;
          this.GetConsumptionsChart(s, e);
        }).catch(() => { this.okconsumption = false; this.weeklyCons = 0; this.keyCons++; });
    },

    GetConsumptionsChart(start, end) {
      const fmt = ds => { const d = new Date(ds); return `${d.getFullYear()}${String(d.getMonth()+1).padStart(2,'0')}${String(d.getDate()).padStart(2,'0')}`; };
      axios.post(this.$store.state.URL_GET_7_DAYS_CONSUMPTION, { sensore: this.sensor_unique, data_inizio: fmt(start), data_fine: fmt(end) })
        .then(res => {
          if (!res.data || res.data.length === 0) { this.series_consumptions = []; this.keyCons++; return; }
          const sorted = res.data.sort((a, b) => a.Data > b.Data ? 1 : -1);
          const dataCount = sorted.length;
          const colW = dataCount <= 1 ? '8%' : dataCount <= 3 ? '20%' : dataCount <= 7 ? '40%' : dataCount <= 14 ? '60%' : '70%';
          const unit = this.consumptionUnit || '';
          this.$set(this, 'series_consumptions', [{ data: sorted.map(e => e.ConsumiGiornalieri), name: this.sensor_name }]);
          let newOpt = {
            ...this.chartOptions_cons,
            plotOptions: { ...this.chartOptions_cons.plotOptions, bar: { ...this.chartOptions_cons.plotOptions.bar, columnWidth: colW, dataLabels: { position: 'center' } } },
            xaxis: { ...this.chartOptions_cons.xaxis, categories: sorted.map(e => e.Data) },
            yaxis: { labels: { style: { colors: '#BFCCE4' }, formatter: val => val != null ? `${val.toFixed(0)}${unit ? ' ' + unit : ''}` : '' } },
            dataLabels: {
              enabled: true,
              formatter: val => val != null ? val.toFixed(0) : '',
              style: { colors: ['#ffffff'], fontWeight: 'bold', fontSize: '12px' }
            },
            tooltip: { y: { formatter: val => val != null ? `${val.toFixed(0)}${unit ? ' ' + unit : ''}` : '' } }
          };
          if (this.currentStartDate && this.currentEndDate)
            newOpt = addPeriodSubtitleToChartOptions(newOpt, this.currentStartDate, this.currentEndDate, this.$i18n.locale || 'en');
          this.$set(this, 'chartOptions_cons', newOpt);
          this.applyChartsTimezone();
          this.keyCons++;
        }).catch(() => { this.series_consumptions = []; this.keyCons++; });
    },

    GetLastRefill(sensore) {
      axios.post(this.$store.state.URL_LASTMANAGED, { sensor: sensore })
        .then(res => { this.last_refill = res.data.length > 0 ? res.data[0].Timestamp_Gestione : 'Not managed yet'; })
        .catch(() => {});
    },

    // ─── Date helpers ───
    subtractDays(n, date = new Date()) { date.setDate(date.getDate() + n); return date; },
    subtractHours(n, date = new Date()) { date.setHours(date.getHours() - n + 1); return date; },

    GetDataByDate() {
      this.overlay = true;
      const s = this.subtractDays(0, new Date(this.date[0])).toISOString().substr(0, 10);
      const e = new Date(this.date[1]).toISOString().substr(0, 10);
      this.currentStartDate = s + ' 00:00:00';
      this.currentEndDate   = e + ' 23:59:59';
      const diffDays = Math.ceil((new Date(e) - new Date(s)) / 86400000);
      const timeFmt = diffDays <= 1 ? 1 : 0;
      this.resetQuickFilterColors();
      this.GetDataStacked(diffDays || 1);
      this.GetSensorData(s, e, timeFmt);
      this.GetConsumptionData(s, e);
      this.fetchRefillStats(this.sensor_unique, this.currentStartDate, this.currentEndDate);
    },

    ChangeDate(period) {
      this.overlay = true;
      let s, e;
      this.resetQuickFilterColors();
      switch (period) {
        case '4h':
          s = this.subtractHours(4, new Date()).toISOString().substr(0, 19);
          e = new Date().toISOString().substr(0, 19);
          this.currentStartDate = s; this.currentEndDate = e;
          this.GetSensorData(s, e, 1); this.GetDataStacked(1);
          this.colore4h = '#213A8F'; break;
        case '1': {
          const today = new Date().toISOString().substr(0, 10);
          s = today; e = today;
          this.currentStartDate = today + ' 00:00:00'; this.currentEndDate = today + ' 23:59:59';
          this.GetSensorData(s, e, 1); this.GetDataStacked(1);
          this.colore1d = '#213A8F'; break;
        }
        case '3':
          s = this.subtractDays(-2, new Date()).toISOString().substr(0, 10);
          e = new Date().toISOString().substr(0, 10);
          this.currentStartDate = s + ' 00:00:00'; this.currentEndDate = e + ' 23:59:59';
          this.GetDataStacked(3); this.GetSensorData(s, e, 0);
          this.colore3d = '#213A8F'; break;
        case '7':
          s = this.subtractDays(-6, new Date()).toISOString().substr(0, 10);
          e = new Date().toISOString().substr(0, 10);
          this.currentStartDate = s + ' 00:00:00'; this.currentEndDate = e + ' 23:59:59';
          this.GetDataStacked(7); this.GetSensorData(s, e, 0);
          this.colore1w = '#213A8F'; break;
        case '14':
          s = this.subtractDays(-13, new Date()).toISOString().substr(0, 10);
          e = new Date().toISOString().substr(0, 10);
          this.currentStartDate = s + ' 00:00:00'; this.currentEndDate = e + ' 23:59:59';
          this.GetDataStacked(14); this.GetSensorData(s, e, 0);
          this.colore2w = '#213A8F'; break;
        case '30':
          s = this.subtractDays(-29, new Date()).toISOString().substr(0, 10);
          e = new Date().toISOString().substr(0, 10);
          this.currentStartDate = s + ' 00:00:00'; this.currentEndDate = e + ' 23:59:59';
          this.GetDataStacked(30); this.GetSensorData(s, e, 0);
          this.colore1m = '#213A8F'; break;
      }
      this.GetConsumptionData(s, e);
      this.fetchRefillStats(this.sensor_unique, this.currentStartDate, this.currentEndDate);
    },

    // ─── CSV export ───
    DownloadCsv() {
      let csv = 'Sensor;DateTime;Fill level\n';
      this.datiPerCsv.forEach(e => { csv += `${this.sensor_name};${e.received_at};${e.tof_distance}%\n`; });
      const link = document.createElement('a');
      link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURI(csv));
      link.setAttribute('download', 'export.csv');
      link.click();
    },
    DownloadCompleteCsv() {
      axios.post(this.$store.state.URL_GET_ALL_DATA_FROM_DYNAMO, {
        sensor_id: this.sensor_unique, from: this.start_complete, to: this.nextDay_complete
      }).then(res => {
        let csv = 'Sensor;DateTime;Fill level\n';
        res.data.forEach(e => {
          const v = 100 - (((Number(e.device_data.tof_distance) - this.minValue) * 100) / this.maxValue).toFixed(0);
          csv += `${this.sensor_name};${e.device_data.received_at};${v}%\n`;
        });
        const link = document.createElement('a');
        link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURI(csv));
        link.setAttribute('download', 'data_export.csv');
        link.click();
      });
    },

    // ─── Route init ───
    initializeComponent() {
      if (this.$route.params?.sensorId) {
        this.scelta = false;
        this.isLoadingFromRoute = true;
      }
      axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT).then(res => {
        res.data.forEach(el => this.clients.push({ text: el.CompanyName, value: el.id }));
        if (!this.$route.params?.sensorId) { this.overlay = false; this.isLoadingFromRoute = false; return; }

        const { company, building, floor, area, sensorId } = this.$route.params;
        const clientObj = this.clients.find(c => c.text === company);
        if (!clientObj) { this.overlay = false; this.isLoadingFromRoute = false; return; }

        this.client = clientObj.value; this.buildingActive = false;
        axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, { companyId: this.client }).then(r => {
          r.data.forEach(el => this.buildings.push({ text: el.BuildingName, value: el.id }));
          const bObj = this.buildings.find(b => b.text === building);
          if (!bObj) { this.overlay = false; this.isLoadingFromRoute = false; return; }
          this.building = bObj.value; this.building_name = bObj.text; this.floorActive = false;
          axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, { buildingId: this.building }).then(r => {
            r.data.forEach(el => this.floors.push({ text: el.FloorName, value: el.id }));
            const fObj = this.floors.find(f => f.text === floor);
            if (!fObj) { this.overlay = false; this.isLoadingFromRoute = false; return; }
            this.floor = fObj.value; this.floor_name = fObj.text; this.areaActive = false;
            axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, { floorId: this.floor }).then(r => {
              r.data.forEach(el => this.areas.push({ text: el.AreaName, value: el.id }));
              const aObj = this.areas.find(a => a.text === area);
              if (!aObj) { this.overlay = false; this.isLoadingFromRoute = false; return; }
              this.area = aObj.value; this.sensorActive = false;
              axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                companyId: this.client, buildingId: this.building,
                floorId: this.floor, areaId: this.area, type: 'Dispenser'
              }).then(r => {
                r.data.forEach(el => this.sensor_items.push({ text: el.DisplayName, value: el }));
                const sObj = this.sensor_items.find(s => s.value.DispenserUnique === sensorId);
                if (!sObj) { this.overlay = false; this.isLoadingFromRoute = false; return; }
                const v = sObj.value;
                this.sensorsValue = v;
                this.sensor_name = v.DisplayName; this.sensor_img = v.DispenserImage;
                this.dispenserSubtype = v.DispenserSubtype || v.dispenserSubtype || '';
                this.sensor_unique = v.DispenserUnique;
                this.sensor_id = v.DispenserId || v.DispenserUnique || v.id;
                this.sensor_id_numeric = v.id || v.DispenserId;
                this.minValue = v.Min_Value; this.maxValue = v.Max_Value;
                this.alertThreshold = Number(v.AlertValue) || 0;
                this.numeroFoglietti = Number(v.NumeroFoglietti) || 0;
                this.okActive = false;
                this.resetQuickFilterColors(); this.colore1d = '#213A8F'; this.date = [];
                this.fetchAlertThreshold(this.sensor_unique);
                this.fetchLastRefill(this.sensor_unique);
                this.LoadData();
                this.$nextTick(() => { this.isLoadingFromRoute = false; });
              }).catch(() => { this.overlay = false; this.isLoadingFromRoute = false; });
            }).catch(() => { this.overlay = false; this.isLoadingFromRoute = false; });
          }).catch(() => { this.overlay = false; this.isLoadingFromRoute = false; });
        }).catch(() => { this.overlay = false; this.isLoadingFromRoute = false; });
      }).catch(() => { this.overlay = false; this.isLoadingFromRoute = false; });
    }
  }
};
</script>

<style scoped>
.sdv2-container { background: #F5F7FB; min-height: 100vh; text-align: left; }

/* Filter bar */
.sdv2-filter-bar { border-radius: 12px !important; border: 1px solid #e8eef6 !important; }

/* Cards */
.sdv2-card { border-radius: 12px !important; border: 1px solid #e8eef6 !important; }

/* Overline label */
.sdv2-overline {
  font-size: 11px; font-weight: 600; letter-spacing: 1.2px;
  color: #8899BB; text-transform: uppercase;
}

/* Badge chips */
.sdv2-badge { font-size: 10px !important; height: 20px !important; }

/* Sensor name */
.sdv2-sensor-name { font-size: 1.7rem; font-weight: 700; color: #213A8F; line-height: 1.2; }

/* Muted text */
.sdv2-muted { color: #8899BB !important; }

/* Info tile */
.sdv2-info-tile { border-radius: 8px !important; border: 1px solid #e8eef6 !important; }
.sdv2-info-value { font-size: 0.8rem; font-weight: 700; color: #213A8F; margin-top: 2px; line-height: 1.3; }

/* Level percentage big number */
.sdv2-level-pct { font-size: 2.8rem; font-weight: 700; color: #213A8F; line-height: 1; }

/* Level bar */
.sdv2-bar-wrapper { position: relative; padding-top: 22px; }
.sdv2-bar-threshold-label {
  position: absolute; top: 0; transform: translateX(-50%);
  background: white; border: 1px solid #FF9800; border-radius: 4px;
  padding: 1px 5px; font-size: 10px; color: #FF9800; white-space: nowrap; z-index: 1;
}
.sdv2-bar {
  height: 26px; background: #BFCCE4; border-radius: 13px;
  position: relative; overflow: visible;
}
.sdv2-bar-fill {
  height: 100%; border-radius: 13px; position: relative;
  background: linear-gradient(to right, #009CAB, #213A8F);
  transition: width 0.6s ease;
}
.sdv2-bar-fill-label {
  position: absolute; right: 10px; top: 50%;
  transform: translateY(-50%); color: white;
  font-weight: 700; font-size: 12px;
}
.sdv2-bar-marker {
  position: absolute; top: -4px; bottom: -4px;
  width: 3px; background: #FF9800; transform: translateX(-50%);
  border-radius: 2px;
}

/* Legend */
.sdv2-legend { gap: 6px; flex-wrap: wrap; margin-top: 8px; }
.sdv2-legend-dot { width: 10px; height: 10px; border-radius: 50%; display: inline-block; margin-right: 4px; }
.sdv2-legend-line { display: inline-block; width: 3px; height: 14px; background: #FF9800; border-radius: 2px; margin-right: 4px; }

/* KPI cards */
.sdv2-kpi-card {
  border: 1px solid #e8eef6 !important; border-radius: 12px !important;
  background: white; height: 100%; text-align: center;
}
.sdv2-kpi-icon { margin-bottom: 6px; }
.sdv2-kpi-label { font-size: 11px; color: #8899BB; line-height: 1.3; min-height: 30px; }
.sdv2-kpi-value { font-size: 1.8rem; font-weight: 700; color: #213A8F; line-height: 1.1; margin: 4px 0; }
.sdv2-kpi-sub { font-size: 11px; color: #8899BB; }

/* Select fields */
#sdv2-filter-bar .v-text-field--outlined fieldset { border-color: #BFCCE4 !important; }
#sdv2-dialog-selects .v-text-field--outlined fieldset { border-color: #BFCCE4 !important; }

</style>
